/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React from 'react';
import {
  TbCircleLetterE,
} from 'react-icons/tb';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  MdOutlineClass,
} from 'react-icons/md';
import { BiBell } from 'react-icons/bi';
import SidebarLink from './SidebarLink';

const SidebarContentTeacher = ({ user }) => {
  const linkColor = user && user.themeColor ? `rgba(${user.themeColor.r}, ${user.themeColor.g}, ${user.themeColor.b})` : '#e9e9e9';
  const linkReverseColor = user && user.themeColor ? `rgba(${255 - user.themeColor.r}, ${255 - user.themeColor.g}, ${255 - user.themeColor.b})` : '#333333';

  return (
    <div className="sidebar__content">
      <ul className="sidebar__block">
        <SidebarLink
          title={(
            <div style={{ display: 'flex', alignItems: 'center' }}>
              Notifications
            </div>
            )}
          linkColor={linkColor}
          linkReverseColor={linkReverseColor}
          icon={<BiBell size={16} style={{ marginBottom: 50 }} />}
          route="/notificationsIntraEW"
        />

        <SidebarLink
          title="Companies"
          linkColor={linkColor}
          linkReverseColor={linkReverseColor}
          icon={<TbCircleLetterE size={16} style={{ marginBottom: 50 }} />}
          route="/companyall/1"
        />
        <SidebarLink
          linkColor={linkColor}
          linkReverseColor={linkReverseColor}
          title="Placement Results"
          icon={<MdOutlineClass size={16} style={{ marginBottom: 50 }} />}
          route="/placement/results"
        />
      </ul>
    </div>
  );
};

function mapState(state) {
  const { user } = state.user;
  return {
    user,
  };
}

export default withRouter(connect(mapState)(SidebarContentTeacher));
